const MessageEnvoyer = (props) => {


    return (

        <div className="message-input">
          <div className="wrap">
          <form className="messages-inputs" onSubmit={(e) => { e.preventDefault(); props.sendMessage(); }}>
            <input type="text" placeholder="Ecrire un message..." value={props.messageInput} onChange={(e) => props.setMessageInput(e.target.value)} />
            <i className="fa fa-paperclip attachment" aria-hidden="true"></i>
            <button className="submit"><i className="fa fa-paper-plane" aria-hidden="true">Envoyer</i></button>
          </form>
          </div>
        </div>
    )

}



export default MessageEnvoyer; 